import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { communityCreatorPausePath, communityCreatorStagePath, newAccountPath } from "@travily/routes";
import { useCreatorTopBarActions } from "@/lib/wizard/use-creator-top-bar-actions";
import { useWizardForm } from "@/lib/wizard/use-wizard-form";
import { CommunityNameStepView } from "./show.view";

interface PageProps {
  stage_index: number;
  total_stages: number;
  stage_order: string[];
  name: string | null;
  profileable_id: number;
}

type FormData = {
  name: string;
};

const CommunityNameStep = ({ stage_index, stage_order, name, profileable_id }: PageProps) => {
  const { bindField, currentStage, totalStages, onBack, onPrimary, primaryPending, onPause } = useWizardForm<FormData>({
    routes: {
      stageUrl: (stage) => communityCreatorStagePath(profileable_id, stage),
      entryUrl: newAccountPath(),
      pauseUrl: communityCreatorPausePath(profileable_id),
    },
    stageName: "name",
    stageIndex: stage_index,
    stageOrder: stage_order,
    initialData: { name: name ?? "" },
  });

  const nameField = bindField("name", { validateOn: "submit" });

  const topBarActions = useCreatorTopBarActions({ onPause });

  return (
    <>
      <Head title={t("web.communities.creator.steps.name.show.meta_title")}>
        <meta name="description" content={t("web.communities.creator.steps.name.show.meta_description")} />
      </Head>
      <CommunityNameStepView
        currentStage={currentStage}
        totalStages={totalStages}
        onBack={onBack}
        topBarActions={topBarActions}
        onPrimary={onPrimary}
        primaryPending={primaryPending}
        value={nameField.value}
        error={nameField.errorMessage}
        onChange={nameField.onChange}
        onBlur={nameField.onBlur}
      />
    </>
  );
};

export default CommunityNameStep;
